webpackJsonp([262516413568633],{

/***/ 744:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/draft-post/"},"excerpt":"I am going to be a little honest here. This is the best Join Kit Opportunity ever from Origami Owl. Even better than the join for $2 Special…","timeToRead":1,"frontmatter":{"title":"August Join Special","category":"Join_Us"}}}]},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"category":"Join_Us"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-join-us-9a2dd64de668792d8845.js